const scope = 'app/components/VerifyCode/';

export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
export const VALIDATE_CODE = `${scope}VALIDATE_CODE`;
export const SEND_VALIDATION_EMAIL = `${scope}SEND_VALIDATION_EMAIL`;
